import React, { useState } from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { GesturePatternPreview } from './GesturePatternPreview';
import { undoableCombatConfigurationCreateAndSelectGesturePattern } from '../../stores/undo/operation/CombatConfigurationSubmitChangesOp';
import { Popup } from '../shared/Popup';
import { UiConstants } from '../../data/UiConstants';
import { undoableSelectGesturePattern } from '../../stores/undo/operation/CombatGesturePatternSelectionOp';
import { combatStore } from '../../stores/CombatStore';
const Container = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRoundGesturePatternSelection__Container",
  componentId: "sc-1ylienp-0"
})(["display:flex;flex-wrap:wrap;padding:0 0.25em;& > *{margin:0.5em 0.25em;}"]);
const SelectableGesturePattern = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRoundGesturePatternSelection__SelectableGesturePattern",
  componentId: "sc-1ylienp-1"
})(["position:relative;border:4px solid ", ";"], props => props.selected ? "blue" : "white");
const AddGesturePatternButton = styled.button.withConfig({
  displayName: "EnemyCombatPresetEditorRoundGesturePatternSelection__AddGesturePatternButton",
  componentId: "sc-1ylienp-2"
})(["width:100px;height:56.25px;"]);
const EditGesturePatternButton = styled.button.withConfig({
  displayName: "EnemyCombatPresetEditorRoundGesturePatternSelection__EditGesturePatternButton",
  componentId: "sc-1ylienp-3"
})(["position:absolute;right:0;top:0;"]);
export const EnemyCombatPresetEditorRoundGesturePatternSelection = observer(({
  round,
  closePopup
}) => {
  const [showEditButtons, setShowEditButtons] = useState(false);
  return /*#__PURE__*/React.createElement(Popup, {
    closePopup: closePopup,
    zIndex: UiConstants.Z_INDEX_ENEMY_COMBAT_PRESET_EDITOR_GESTURE_SELECTION_POPUP,
    windowStyle: {
      maxWidth: "636px"
    }
  }, /*#__PURE__*/React.createElement(Container, null, combatStore.config.gesturePatterns.map(pattern => /*#__PURE__*/React.createElement(SelectableGesturePattern, {
    key: pattern.$modelId,
    selected: round.hasPlayerDefensePatternId(pattern.$modelId),
    onClick: () => round.togglePlayerDefensePatternId(pattern.$modelId)
  }, /*#__PURE__*/React.createElement(GesturePatternPreview, {
    gesturePattern: pattern,
    width: 100
  }), showEditButtons && /*#__PURE__*/React.createElement(EditGesturePatternButton, {
    onClick: e => {
      e.stopPropagation();
      undoableSelectGesturePattern(pattern.$modelId);
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faEdit
  })))), /*#__PURE__*/React.createElement(SelectableGesturePattern, {
    selected: false
  }, /*#__PURE__*/React.createElement(AddGesturePatternButton, {
    onClick: () => undoableCombatConfigurationCreateAndSelectGesturePattern()
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPlus
  }))), /*#__PURE__*/React.createElement(SelectableGesturePattern, {
    selected: false
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: showEditButtons,
    onChange: () => setShowEditButtons(!showEditButtons)
  }), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faEdit
  })))));
});